import Caixa from './Caixa'
import HeaderVerde from './HeaderVerde'
import Input from './Input'
import React from 'react'

import { useSelector, useDispatch } from 'react-redux'

const DadosIniciais = (props) => {
    const modulo = props.modulo
    const ficha = useSelector((state) => state.addForm.modulos)

    return (
        <Caixa>
            <HeaderVerde texto="DADOS INICIAIS" />
            <div style={{ margin: "auto", width: "60vw" }}>
                <div style={{ textAlign: "left" }}>
                    <Input label="Data" nome="data" tipo="date" modulo={modulo} index={0}
                        componentDisplay="inline-grid" widthWeb="28vw" widthMobile="80vw" marginR="4vw" />
                    <div style={{
                        display: "inline-grid", width: "28vw",
                        textAlign: "left", color: "#484848", marginTop: "2vh"
                    }}>
                        <div>CPF/CNPJ</div>
                        <div style={{
                            width: "28vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                            borderRadius: "5px", minHeight: "5px"
                        }}>{ficha.dadosIniciais[0].cpfCnpj}</div>
                    </div>
                </div>
                <div style={{ textAlign: "left" }}>
                    <div style={{
                        display: "inline-grid", width: "28vw",
                        textAlign: "left", color: "#484848", marginTop: "2vh", marginRight: "4vw"
                    }}>
                        <div>Processo</div>
                        <div style={{
                            width: "28vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                            borderRadius: "5px", minHeight: "5px"
                        }}>{ficha.dadosIniciais[0].processo}</div>
                    </div>
                    <Input label="Termo de Visita" nome="tv" modulo={modulo} index={0}
                        componentDisplay="inline-grid" widthWeb="28vw" widthMobile="80vw" />
                </div>
                <div style={{ textAlign: "left" }}>
                    <Input label="Entrada" nome="entrada" tipo="time" modulo={modulo} index={0}
                        componentDisplay="inline-grid" widthWeb="28vw" widthMobile="80vw" marginR="4vw" />
                    <Input label="Saída" nome="saida" tipo="time" modulo={modulo} index={0}
                        componentDisplay="inline-grid" widthWeb="28vw" widthMobile="80vw" />
                </div>
            </div>
        </Caixa>
    )
}

export default DadosIniciais